import React from 'react'

import ConnectedDatePicker from 'src/comps/ConnectedDatePicker'
import ConnectedSuggester from 'src/comps/SuggesterConnected'
import PaxesConnected from 'src/comps/PaxesConnected'
import { SearchMode, SearchUrl } from 'src/types/search'

import { OmniSearchBase, OmniSearchContent } from './styles'

import { setSearchParamsLocalStorage } from 'lib/storage'
import { getPaxesfromUrlParams } from 'client/utils'

import SearchIcon from 'client/icons/Search'
import SearchButton from '../SearchButton'
import { useBusiness } from 'src/hooks/useBusiness'
import { AFFILIATE_EBOOKING } from 'src/constants/affiliates'
import noop from 'lodash/noop'
import cn from 'classnames'

interface IProps {
  mode: SearchMode
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  preventNavigation?: boolean
  searchUrl: SearchUrl
  disabled?: boolean
  stacked?: boolean
  smallBtn?: boolean
}

const OmniSearch = ({
  mode,
  preventNavigation = true,
  searchUrl,
  onClick = noop,
  disabled,
  stacked,
  smallBtn = false,
}: IProps) => {
  const { href } = searchUrl
  const { affiliate } = useBusiness()
  const isEbooking = affiliate === AFFILIATE_EBOOKING

  const handleSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    onClick(e)

    const paxes = getPaxesfromUrlParams({
      adults: href.query.adults,
      children: href.query.children,
    })

    setSearchParamsLocalStorage({
      checkIn: href.query.checkin,
      checkOut: href.query.checkout,
      adults: paxes.adults,
      children: paxes.children,
    })
  }

  let content = (
    <>
      <ConnectedSuggester mode={mode} className="suggester-wrapper" />
      <ConnectedDatePicker mode={mode} />
      <PaxesConnected mode={mode} disabled={disabled} />
      <SearchButton
        onClick={handleSearch}
        fullWidth={mode === SearchMode.Full}
        preventNavigation={preventNavigation}
        searchUrl={searchUrl}
        small={smallBtn && mode === SearchMode.Borderless}
      />
    </>
  )

  if (mode === SearchMode.Readonly) {
    content = (
      <>
        <SearchIcon data-testid="search-icon" size={20} />
        <ConnectedSuggester mode={mode} className="suggester-wrapper" />

        <OmniSearchContent>
          <ConnectedDatePicker mode={mode} />
          <PaxesConnected mode={mode} />
        </OmniSearchContent>
      </>
    )
  }

  return (
    <OmniSearchBase
      className={cn(mode, { stacked })}
      data-testid="omni-search"
      isEbooking={isEbooking}
      disabled={disabled}
    >
      {content}
    </OmniSearchBase>
  )
}

export default OmniSearch
